import { BookPlus } from "lucide-react";
import { usePromptLibraryContext } from "@/modules/promptLibrary/usePromptLibraryContext";
import * as analytics from "@/services/analytics";
import { ACTION_BUTTON_STYLE } from "../constants";
import type { PromptSource } from "../types";

interface Props {
  content: string;
  source: PromptSource;
}

export const AddToLibraryButton = ({ content, source }: Props) => {
  const { openCreatePromptLibraryModal } = usePromptLibraryContext();

  const handleAddToLibrary = () => {
    analytics.addPromptToLibrary(content);
    openCreatePromptLibraryModal(content, source);
  };

  return (
    <button className={ACTION_BUTTON_STYLE} onClick={handleAddToLibrary}>
      <BookPlus size={14} className="mr-1" />
      Add to library
    </button>
  );
};
